import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import store from "@/store";
Vue.use(VueRouter);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});

const routes = [
  {
    path: "/",
    name: "Inicio",
    meta: {
      title: "DOMOSA Decoraciones",
    },
    component: () => import(/* "inicio" */ "../views/Inicio"),
  },
  {
    path: "*",
    meta: {
      title: "DOMOSA Decoraciones",
    },
    component: () => import(/* "inicio" */ "../views/Inicio"),
  },
  {
    path: "/articulo/:codart",
    meta: {
      title: "REF: ",
    },
    name: "Producto",
    component: () =>
      import(/* "Detalle Articulo" */ "../components/DetalleArticulo"),
  },
  {
    path: "/presupuesto/:numdoc",
    name: "Presupuesto",
    component: () =>
      import(/* "Detalle Articulo" */ "../components/PresuMobilData"),
  },
  {
    path: "/cliente/:codcli",
    name: "Cliente",
    component: () =>
      import(
        /* "Info Consolidado del Cliente" */ "../components/DetalleCliente"
      ),
    meta: {
      title: "CLIENTES DOMOSA DECORACIONES",
    },
  },
  {
    path: "/catalogo/:div/:dep/:cat/:scat",
    meta: {
      title: "ARTICULOS",
    },
    name: "Categoria",
    component: () =>
      import(
        /* Filtro Categorias almacena el grid */ "../components/FiltroCat"
      ),
  },
  {
    path: "/articulos/:txtbuscar",
    meta: {
      title: "BUSQUEDA DE ARTICULOS",
    },
    name: "Articulos",
    component: () => import(/* "articulos" */ "../components/Articulos"),
  },
  {
    path: "/subcategoria/:div/:dep/:cat",
    meta: {
      title: " ",
    },
    name: "Subcat",
    component: () => import("../components/GridSubcat"),
  },
  {
    path: "/carrito/",
    name: "CarritoCompras",
    component: () => import("../views/CarritoCompras"),
    meta: {
      title: "CARRITO DOMOSA DECORACIONES",
    },
  },
  {
    path: "/audit/",
    name: "AuditDomo",
    component: () => import("../views/AuditoriaDomo"),
    meta: {
      title: "AUDITORIA",
    },
  },
  {
    path: "/agenda/",
    name: "AgendaVista",
    component: () => import("../views/AgendaVisitasGet"),
    meta: {
      title: "VER AGENDA",
    },
  },
  {
    path: "/agenda/:dist/:cli",
    name: "AgendaVistaAdm",
    component: () => import("../views/AgendaVisitasSet"),
    meta: {
      title: "GESTION AGENDA",
    },
  },
  {
    path: "/pedidoconfirmado/:documento",
    name: "PedidoPresupuesto",
    component: () => import("../components/Pedido/PedidoConfirmado"),
    meta: {
      title: "PRESUPUESTOS/PEDIDOS",
    },
  },
  {
    path: "/mantenimiento/",
    name: "Mantenimiento",
    meta: {
      title: "MANTENIMIENTOS www.domosadecoraciones.com",
    },
    children: [
      ,
      {
        path: "/mantenimiento/indeslit",
        name: "MantIndeslit",
        component: () => import("../components/MantenimientoCatalogo"),
        meta: {
          title: "MANTENIMIENTO CATALOGO DE PRODUCTOS",
        },
      },

      {
        path: "/mantenimiento/carousel",
        name: "MantCarousel",
        component: () => import("../components/MantenimientoCarousel"),
        meta: {
          title: "MANTENIMIENTO CAROUSEL",
        },
      },
      {
        path: "/mantenimiento/featureadd",
        name: "MantFeature",
        component: () => import("../components/MantenimientoFeatureAdd"),
        meta: {
          title: "MANTENIMIENTO CARACTERISTICAS",
        },
      },
      {
        path: "/mantenimiento/testimonio",
        name: "MantTestimonio",
        component: () => import("../components/MantenimientoTestimonio"),
        meta: {
          title: "MANTENIMIENTO TESTIMONIOS",
        },
      },
      {
        path: "/mantenimiento/galeria",
        name: "MantGalery",
        component: () => import("../components/MantenimientoGaleria"),
        meta: {
          title: "MANTENIMIENTO GALERIA DE IMAGENES",
        },
      },
    ],
    component: () => import("../components/GridMantenimiento"),
  },
  {
    path: "/testimonios/",
    name: "TestimonioCliente",
    component: () => import("../views/Testimonios"),
    meta: {
      title: "TESTIMONIOS DE NUESTROS CLIENTES",
    },
  },
  {
    path: "/centroservicio/",
    name: "CentroServicio",
    component: () => import("../views/CentroServicio"),
    meta: {
      title: "CENTROS DE SERVICIO",
    },
  },
  //
  {
    path: "/detalle/:articulo",
    name: "Detalle",
    component: () => import("../views/ArticuloDetalle"),
    meta: {
      title: "REF: ",
    },
  },
  {
    path: "/descargas/",
    name: "Descargas",
    component: () => import("../views/Descargas"),
    meta: {
      title: "DESCARGAS",    
    },
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  //ejecutar aqui las mutaciones para limpiar los estados al cambiar de ruta
  store._mutations["clr_page"][0]();
  store._mutations["CLR_BUSCARPROMO"][0]();
  store._mutations["setMenuDomoDeco"][0](false);
  store._mutations["setLoadingSubCat"][0](false);
  store._mutations["CLR_DISPONIBLE"][0]();
  const authenticatedUser = store.state.dataUser.IndAutenticado;
  const requiresAuth = to.matched.some((record) => record.meta.Autenticado);
  if (requiresAuth && !authenticatedUser) next("/");
  else next();

  const newMetaTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (
    (to.name == "Subcat" || to.name == "Categoria") &&
    store.state.maestro.length != 0
  ) {
    const nb = store.state.maestro.ttCategoria
      .filter((item) => item.Categoria == to.params.cat)
      .map((item) => item.Nombre);
    if (newMetaTitle) document.title = newMetaTitle.meta.title + " " + nb[0];
  } else if (to.name == "Detalle") {
    let codArt = to.params.articulo ? to.params.articulo : "";
    if (newMetaTitle) document.title = newMetaTitle.meta.title + codArt;
  } else {
    if (newMetaTitle) document.title = newMetaTitle.meta.title;
  }

  next();
});
export default router;
